import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { Box, Card } from "@mui/material";
import React, { useEffect, useState } from "react";

import TabPanel from "../../helpers/TabPanel";
import AssignedTaskManagement from "./AssignedTaskManagement";
import TaskManagement from "./TaskManagement";
import TaskInitiations from "./TaskInitiations";
import TabBoxComponent from "components/UI/TabBox";

const TasksManagement = ({
    location,
    SetSelectedMenu,
    GetAllResources,
    systemSettings
}) => {
    const mainBackground = systemSettings?.mainBackground;

    const [tabValue, setTabValue] = useState(location?.state?.tab ?? 0);
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        SetSelectedMenu({
            menu: "my_assignments",
            title: "Tasks Management",
        });
        GetAllResources();
    }, []);
    return (
        <Card>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>

                <TabBoxComponent
                    selectedValue={tabValue}
                    handleTabChange={handleChange}
                    tabList={[
                        {
                            label: "Initiated by me",
                            tabValue: 0,
                            permissionCode: "menu.task.management",
                        },
                        {
                            label: "Assigned to me",
                            tabValue: 1,
                            permissionCode: "menu.task.management",
                        },
                        {
                            label: "Team Initiations",
                            tabValue: 2,
                            permissionCode: "menu.task.management",
                        },
                    ]}
                />

                <TabPanel index={0} value={tabValue} p={0}>
                    <TaskManagement
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>
                <TabPanel index={1} value={tabValue} p={0}>
                    <AssignedTaskManagement
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>

                <TabPanel index={2} value={tabValue} p={0}>
                    <TaskInitiations
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>
            </Box>
        </Card>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TasksManagement);